<template>
    <div>
        <!--Edit-->
        <div class="container">
            <div class="page-inner">
                <div class="page-header">
                    <h3 class="fw-bold mb-3">Total Anual</h3>
                    <ul class="breadcrumbs mb-3">
                        <li class="nav-home"> <router-link to="/home"><i class="fa fa-home"></i></router-link> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item">Total Anual</li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <v-tabs v-model="tab" color="deep-purple-accent-4" bg-color="#dadcdf">
                                    <v-tab value="dados" class="tabinfo"
                                        style="font-size: 13px;text-transform: none !important;">Filtros</v-tab>
                                </v-tabs>
                                <v-window v-model="tab">
                                    <v-window-item value="dados">
                                        <v-form>
                                            <v-container>
                                                <div class="row">
                                                    <div class="col-md-6 col-lg-6" v-if="User.garid == 0">
                                                        <div class="form-group">
                                                            <label>Garantidora</label>
                                                            <select v-model="GarantidoraSelected"
                                                                class="form-select form-control"
                                                                @change="BuscaImobiliarias()">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionTipo in ListGarantidorasGeral"
                                                                    :key="optionTipo.garId" :value="optionTipo.garId">{{
                                                                        optionTipo.garNomeEmpresa }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 col-lg-6"
                                                        v-if="User.tpeid == 1 || User.garid == 0">
                                                        <div class="form-group">
                                                            <label>Imobiliaria</label>
                                                            <select v-model="ImobiliariaSelected"
                                                                class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionTipo in ListImobiliarias"
                                                                    :key="optionTipo.imoId" :value="optionTipo.imoId">{{
                                                                        optionTipo.imoNomeEmpresa }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Ano Referência</label>
                                                            <select v-model="AnoSelected"
                                                                class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionTipo in ListAnoGeral"
                                                                    :key="optionTipo.Id" :value="optionTipo.Id">{{
                                                                        optionTipo.Nome }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12 col-lg-12">
                                                        <div class="form-group">
                                                            <button type="button" class="btn btn-info"
                                                                style="color:#ffffff;" @click="Filtar()">
                                                                Pesquisar
                                                            </button>
                                                            <a href="#" @click="Cancel()"
                                                                class="btn btn-link">Cancelar</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-container>
                                        </v-form>
                                    </v-window-item>
                                </v-window>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--Grid-->
        <div class="container">
            <div class="page-inner">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title">Resultado</h4>
                                </div>

                            </div>
                            <div class="card-body"
                                v-if="ListCobrancas != '' && ListGarantidorasGeral != null && ListImobiliariasGeral != ''">
                                <v-row>
                                    <v-col cols="12" md="6" style="padding-bottom: 30px;">
                                        <v-text-field v-model="searchValue" label="Pesquisa" variant="underlined"
                                            required></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="3" style="text-align: right;padding-right: 15px;">
                                        <button @click="exportCSV" class="btn-sm btn-warning">Exportar CSV</button>
                                    </v-col>
                                    <v-col cols="12" md="3"
                                        style="padding-bottom: 30px;text-align: right;padding-right: 25px;">
                                        <h3>Total R$ {{ TotalGrid }}</h3>
                                    </v-col>
                                </v-row>
                                <easy-data-table :headers="headers" :items="ListCobrancas" v-model="itemsSelected"
                                    alternating theme-color="#364f66" table-class-name="customize-table"
                                    header-text-direction="center" body-text-direction="center"
                                    rows-per-page-message="Linhas por pagina" :search-value="searchValue">
                                    <template #item-garId="item">
                                        <span>{{ListGarantidorasGeral.filter(x => x.garId ==
                                            item.garId)[0].garNomeEmpresa}}</span>
                                    </template>
                                    <template #item-imobId="item">
                                        <span>{{ListImobiliariasGeral.filter(x => x.imoId ==
                                            item.imobId)[0].imoNomeEmpresa}}</span>
                                    </template>
                                    <template #item-janeiro="item">
                                        <span>{{ formatarValor(item.janeiro) }}</span>
                                    </template>
                                    <template #item-fevereiro="item">
                                        <span>{{ formatarValor(item.fevereiro) }}</span>
                                    </template>
                                    <template #item-marco="item">
                                        <span>{{ formatarValor(item.marco) }}</span>
                                    </template>
                                    <template #item-abril="item">
                                        <span>{{ formatarValor(item.abril) }}</span>
                                    </template>
                                    <template #item-maio="item">
                                        <span>{{ formatarValor(item.maio) }}</span>
                                    </template>
                                    <template #item-junho="item">
                                        <span>{{ formatarValor(item.junho) }}</span>
                                    </template>
                                    <template #item-julho="item">
                                        <span>{{ formatarValor(item.julho) }}</span>
                                    </template>
                                    <template #item-agosto="item">
                                        <span>{{ formatarValor(item.agosto) }}</span>
                                    </template>
                                    <template #item-setembro="item">
                                        <span>{{ formatarValor(item.setembro) }}</span>
                                    </template>
                                    <template #item-outubro="item">
                                        <span>{{ formatarValor(item.outubro) }}</span>
                                    </template>
                                    <template #item-novembro="item">
                                        <span>{{ formatarValor(item.novembro) }}</span>
                                    </template>
                                    <template #item-dezembro="item">
                                        <span>{{ formatarValor(item.dezembro) }}</span>
                                    </template>
                                    <template #item-totalAno="item">
                                        <span>{{ formatarValor(item.totalAno) }}</span>
                                    </template>
                                </easy-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import moment from 'moment'

export default {
    name: 'ControleCobrancasView',
    components: {
        EasyDataTable,
        moment
    },
    data: () => ({
          User: {
            garid:0,
            tpeid:0,
            pesid:0,
        },
        editor: DecoupledEditor,
        tab: null,
        searchValue: '',
        itemsSelected: [],
        ListCobrancasGeral: [],
        ListCobrancas: [],
        GarantidoraSelected: null,
        ListGarantidorasGeral: [],
        ImobiliariaSelected: null,
        ListImobiliariasGeral: [],
        ListImobiliarias: [],
        PagamentoSelected: null,
        ListPagamentosGeral: [],
        AnoSelected: null,
        ListAnoGeral: [],
        MesSelected: null,
        ListMesGeral: [
            { Id: 1, Nome: 'Janeiro' },
            { Id: 2, Nome: 'Fevereiro' },
            { Id: 3, Nome: 'Março' },
            { Id: 4, Nome: 'Abril' },
            { Id: 5, Nome: 'Maio' },
            { Id: 6, Nome: 'Junho' },
            { Id: 7, Nome: 'Julho' },
            { Id: 8, Nome: 'Agosto' },
            { Id: 9, Nome: 'Setembro' },
            { Id: 10, Nome: 'Outubro' },
            { Id: 11, Nome: 'Novembro' },
            { Id: 12, Nome: 'Dezembro' }
        ],
        TotalGrid: 0,
    }),
    methods: {
        onReady(editor) {
            // Insert the toolbar before the editable area.
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
        formattedDate(value) {
            if (value != null || value != "") {
                return this.$moment(value).format('DD/MM/YYYY')
            }
            else {
                return "";
            }

        },
        formatarValor(valor) {
            if (valor == null || valor === '') {
                return '';
            }

            // 2) Tenta converter pra número
            // Se vier como string “2580.08” ou já for number, isso resolve
            const num = Number(valor);

            // 3) Se não for um número válido, faz fallback
            if (isNaN(num)) {
                return '';
            }

            // 4) Agora que é número, aplica o toLocaleString com duas casas decimais
            return num.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },
        BuscaImobiliarias() {
            axios.get(`/Telas/TotalAnualPrevistoGarantidoras/GetByGarIdParIdImobiliarias/` + this.GarantidoraSelected + '/0')
                .then(response => {
                    if (response.data.length > 0) {
                        this.ListImobiliarias = response.data.sort((a, b) =>
                        a.imoNomeEmpresa.localeCompare(
                        b.imoNomeEmpresa,
                        'pt',
                        { sensitivity: 'base' }
                        )
                    );
                    }
                    else {
                        this.ListImobiliarias = [];
                    }
                });
        },
        Cancel() {
            //window.location.reload();
            this.$router.go(0);
        },
        Filtar() {
            if (this.GarantidoraSelected === '' || this.GarantidoraSelected === null) {
                this.$mensagemAviso("Selecione uma Garantidora.")
            }
            else if (this.AnoSelected === '' || this.AnoSelected === null) {
                this.$mensagemAviso("Selecione Ano Referência.")
            }
            else {
                let imob = 0;
                let ano = 0;
                if (this.ImobiliariaSelected != null) {
                    imob = this.ImobiliariaSelected;
                }
                if (this.AnoSelected != null) {
                    ano = this.AnoSelected;
                }

                axios.get(`/Telas/TotalAnualPrevistoGarantidoras/GetGarIdImoIdAnual/` + this.GarantidoraSelected + '/' + imob + '/' + ano)
                    .then(response => {
                        this.ListCobrancasGeral = response.data;
                        this.ListCobrancas = this.ListCobrancasGeral;
                        this.TotalGrid = this.formatarValor(this.ListCobrancasGeral.reduce(
                            (soma, item) => soma + Number(item.totalAno || 0),
                            0
                        ));
                        //console.log('ListCobrancasGeral')
                        //console.log(this.ListCobrancasGeral)
                    });
            }
        },
        montaGrid() {
            this.headers = [];
            if (this.User.garid == 0) {
                this.headers.push({ text: "Garantidora", value: "garId", sortable: true, });
            }
            if (this.User.tpeid != 3) {
                this.headers.push({ text: "Imobiliaria", value: "imobId", sortable: true, });
            }
            this.headers.push({ text: "Pagamento", value: "pmbFormaPgto", sortable: true, });
            this.headers.push({ text: "Janeiro", value: "janeiro", sortable: true, });
            this.headers.push({ text: "Fevereiro", value: "fevereiro", sortable: true, });
            this.headers.push({ text: "Março", value: "marco", sortable: true, });
            this.headers.push({ text: "Abril", value: "abril", sortable: true, });
            this.headers.push({ text: "Maio", value: "maio", sortable: true, });
            this.headers.push({ text: "Junho", value: "junho", sortable: true, });
            this.headers.push({ text: "Julho", value: "julho", sortable: true, });
            this.headers.push({ text: "Agosto", value: "agosto", sortable: true, });
            this.headers.push({ text: "Setembro", value: "setembro", sortable: true, });
            this.headers.push({ text: "Outubro", value: "outubro", sortable: true, });
            this.headers.push({ text: "Novembro", value: "novembro", sortable: true, });
            this.headers.push({ text: "Dezembro", value: "dezembro", sortable: true, });

            this.headers.push({ text: "Total", value: "totalAno", sortable: true, });
        },
        exportCSV() {
            if (this.ListCobrancas.length === 0) {
                alert("Não há dados para exportar.");
                return;
            }

            let _Garantidora = "Todas";
            let _Imobliaria = "Todas";
            let _Ano = "Todos";

            if (this.GarantidoraSelected != '' && this.GarantidoraSelected != null) {
                _Garantidora = this.ListGarantidorasGeral.filter(x => x.garId == this.GarantidoraSelected)[0].garNomeEmpresa;
            }

            if (this.ImobiliariaSelected != '' && this.ImobiliariaSelected != null) {
                _Imobliaria = this.ListImobiliariasGeral.filter(x => x.imoId == this.ImobiliariaSelected)[0].imoNomeEmpresa;
            }

            if (this.AnoSelected != '' && this.AnoSelected != null) {
                _Ano = this.ListAnoGeral.filter(x => x.Id == this.AnoSelected)[0].Nome;
            }
            // Cria as linhas de filtros (ajuste os nomes dos filtros conforme necessário)
            const filtroCSV =
                `Garantidora: ${_Garantidora}\n` +
                `Imobiliária: ${_Imobliaria}\n` +
                `Ano: ${_Ano}\n\n`;

            const csvHeader = this.headers
                .slice(2)
                .map(h => h.text)
                .join(";") + "\n";

            // 2) Liste as chaves dinamicamente (aqui já só as que sobraram após slice)
            const keys = this.headers
                .slice(2)
                .map(h => h.value);


            const csvRows = this.ListCobrancas
                .map(item => {
                    return keys
                        .map(key => {
                            const val = item[key];

                            // 1) Se for campo de forma de pagamento, devolve “cru”
                            if (key === 'pmbFormaPgto') {
                            return val || '';
                            }

                            // 2) Para qualquer outro campo não-nulo, formata o valor
                            if (val != null) {
                            return this.formatarValor(val);
                            }

                            // 3) Fallback para string vazia
                            return '';
                        })
                        .join(";");
                })
                .join("\n");

            // Concatena os filtros, o cabeçalho e as linhas de dados
            const csvContent = "data:text/csv;charset=utf-8,\uFEFF" + filtroCSV + csvHeader + csvRows;

            // Cria o link de download
            const encodedUri = encodeURI(csvContent);
            const link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", "RelatorioTotalAnualCobrancas.csv");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        async Get() {
     await axios.get(`/Telas/TotalAnualPrevistoGarantidoras/GetDados`)
                .then(response => {
                    this.ListGarantidorasGeral = response.data.garGarantidoras.filter(x => x.garAtivo).sort((a, b) =>
                        a.garNomeEmpresa.localeCompare(
                            b.garNomeEmpresa,
                            'pt',
                            { sensitivity: 'base' }
                        )
                    );
                    this.User.tpeid = response.data.tpeId
                    this.User.garid = response.data.garId
                     this.User.pesid = response.data.pesId
                    if (this.User.garid != 0) {
                        this.GarantidoraSelected = this.User.garid;
                        this.BuscaImobiliarias();
                    }
                    if (this.User.tpeid == 3) {
                        this.ImobiliariaSelected = this.User.pesid;
                    }

                     this.ListImobiliariasGeral = response.data.imobiliarias.filter(x => x.imoAtivo).sort((a, b) =>
                        a.imoNomeEmpresa.localeCompare(
                        b.imoNomeEmpresa,
                        'pt',
                        { sensitivity: 'base' }
                        )
                    );

                      this.ListAnoGeral = [];
            const anoAtual = new Date().getFullYear();
            this.ListAnoGeral = Array.from({ length: 7 }, (_, i) => {
                const ano = anoAtual - 1 + i;
                return { Id: ano, Nome: String(ano) };
            });
                       this.ListPagamentosGeral = response.data.cadFormasPagamentos;
                      this.montaGrid();
                });
          
        }
    },
    created() {
        this.Get();

    },
}
</script>

<style scoped>
.tabinfo {
    font-size: 14px;
    text-transform: capitalize;
}
</style>
